import React, { FunctionComponent } from "react";
import { Combobox, ComboboxButton } from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";
import { cn } from "../../../utils/cn";

export interface SelectButtonProps {
  className?: string;
}

/**
 * Select toggle button to show / hide results
 */
export const SelectButton: FunctionComponent<SelectButtonProps> = ({
  className,
}) => {
  const css = cn(
    "absolute inset-y-0 right-2 flex items-center disabled:hidden",
    className,
  );
  return (
    <ComboboxButton className={css}>
      <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
    </ComboboxButton>
  );
};
